<template>
    <div>
        <vs-alert icon-pack="feather" icon="icon-alert-circle" :active="clientFormError" color="danger"
                  class="pl-2 mb-4">
            Le formulaire ci-dessous contient des erreur, l'enregistrement n'a pas été effectué.
        </vs-alert>
        <div class="vx-row text-base" :class="{'loader': clientLoading }" v-if="clientForm">
            <div class="vx-col w-full mb-2">
                <div class="vx-row mb-2 items-center">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                            class="w-full"
                            v-model="clientForm.address1"
                            label="Adresse 1"
                            placeholder="adresse 1"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                            class="w-full"
                            v-model="clientForm.address2"
                            label="Adresse 2"
                            placeholder="adresse 2"/>
                    </div>
                </div>
                <div class="vx-row mb-4 items-center">
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                            :danger="clientForm.code_postal ? isInvalid(clientForm.code_postal, 'code_postal') : false"
                            danger-text="Vous devez saisir un code postal"
                            val-icon-danger="icon-x"
                            val-icon-pack="feather"
                            label="Code postal"
                            class="w-full"
                            v-model="clientForm.code_postal"
                            placeholder="Code postal"/>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                            label="city"
                            class="w-full"
                            v-model="clientForm.city"
                            placeholder="city"/>
                    </div>

                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                            label="country"
                            class="w-full"
                            v-model="clientForm.country"
                            placeholder="country"/>
                    </div>
                </div>

            </div>


            <div class="vx-col w-full sm:w-1/2 mb-2">
                <vs-input
                    label="Site web"
                    class="w-full"
                    v-model="clientForm.website"
                    placeholder="https://..."/>
            </div>
            <div class="vx-col w-full sm:w-1/2 mb-2">
                <vs-input
                    class="w-full"
                    :danger="clientForm.telephone ? isInvalid(clientForm.telephone, 'telephone') : false"
                    danger-text="Vous devez saisir un téléphone valide"
                    val-icon-danger="icon-x"
                    val-icon-pack="feather"
                    type="telephone"
                    v-model="clientForm.telephone"
                    label="Téléphone"
                    placeholder="téléphone"/>
            </div>
            <div class="vx-col w-full mb-2">
                <vs-input
                    :danger="clientForm.email ? isInvalid(clientForm.email, 'email') : false"
                    danger-text="Vous devez saisir un email valide"
                    val-icon-danger="icon-x"
                    val-icon-pack="feather"
                    type="email"
                    icon-pack="feather"
                    icon="icon-mail"
                    class="w-full"
                    v-model="clientForm.email"
                    label="Email"
                    placeholder="Email"
                />
            </div>
        </div>

        <div class="vx-row items-center text-sm">
            <div class="vx-col w-full sm:w-1/3 mb-2">
                <vs-input
                    class="w-full"
                    v-model="clientForm.rcs"
                    label="N° RCS"
                    placeholder="N° RCS"/>
            </div>
            <div class="vx-col w-full sm:w-1/3 mb-2">
                <vs-input
                    class="w-full"
                    v-model="clientForm.siret"
                    label="N° Siret"
                    placeholder="N° siret"/>
            </div>
            <div class="vx-col w-full sm:w-1/3 mb-2">
                <vs-input
                    class="w-full"
                    v-model="clientForm.tva_intracom"
                    label="N° TVA"
                    placeholder="N° TVA"/>
            </div>
        </div>

        <!-- form footer -->
        <vs-row vs-justify="flex-end" class="mt-10 pb-8 pr-4">
            <vs-button type="border" color="primary" @click.native="onCancelForm()">
                Annuler
            </vs-button>
            <vs-button :disabled="clientFormError" type="gradient" color="success" class="ml-4" icon-pack="feather"
                       icon="icon-save" @click="onUpdateProfile">
                Enregistrer
            </vs-button>
        </vs-row>

    </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import {formValidationMixins} from '@/mixins/formValidationMixins.js'

export default {
  name: 'ClientForm',
  mixins: [formValidationMixins],
  props: {
    client: {
      type: Object,
      required: true
    },
    clientLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      clientForm: {
        id: -1,
        address1: 'M',
        address2: '',
        code_postal: '',
        city: '',
        country: '',
        website: '',
        telephone: '',
        email: '',
        rcs: '',
        siret: '',
        tva_intracom: ''
      }
    }
  },
  computed: {
    ...mapState({
      clientFormError () {
        return (
          (this.clientForm.code_postal ? this.isInvalid(this.clientForm.code_postal, 'code_postal') : false) ||
                    (this.clientForm.email ? this.isInvalid(this.clientForm.email, 'email') : false) ||
                    (this.clientForm.telephone ? this.isInvalid(this.clientForm.telephone, 'telephone') : false)
        )
      }
    })
  },
  created () {
    if (!this.client) this.emit('onCancel')
    this.setFormData()
  },
  methods: {
    ...mapActions('client', ['saveClient']),
    setFormData () {
      this.clientForm = {
        id: this.client.id,
        address1: this.client.address1,
        address2: this.client.address2,
        code_postal: this.client.code_postal,
        city: this.client.city,
        country: this.client.country,
        website: this.client.website,
        telephone: this.client.telephone,
        email: this.client.email,
        rcs: this.client.rcs,
        siret: this.client.siret,
        tva_intracom: this.client.tva_intracom
      }
    },

    onCancelForm () {
      this.$emit('onCancel')
    },

    onUpdateProfile () {
      if (!this.clientFormError) {
        this.saveClient(this.clientForm).then(() => {
          // console.log(res)

          this.$emit('onSaved')
        })
      }
    }
  }
}
</script>

<style lang="scss">
</style>
